import React from 'react';
import { connect } from 'react-redux';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import * as PropTypes from 'prop-types';

import ZpButton from 'components/zpButton';
import { withZippiaHistory } from 'hooks';
import {getStateName, importStatic, ismobileDevice} from 'utils';

import AutosuggestInput from '../components/autosuggestInput';
import { surveyService } from '../services';
import { closeLocationInputModal,openSignUpModal } from '../store/modals/actions';
import { POPUP_SURVEY_SOURCE } from '../utils/constant';

import FeaturedIn from './section/featuredInSection';

import locationInputClasses from '../components/jobs/card/locationInputFieldPopup.module.css';
import surveyPopupClasses from '../components/surveyPopup/surveyPopup.module.css';
import styles from './HomeSurveyEntry.module.css';

const propTypes = {
  zippiaHistory: PropTypes.any.isRequired,
  modals: PropTypes.any,
  openSignUpModal: PropTypes.func.isRequired,
  user: PropTypes.shape({}),
};

const defaultProps = {
  modals: {},
  user: {},
};

class HomeSurveyEntry extends React.PureComponent {
  constructor(props) {
    super(props);
    this.elementRef = React.createRef();
    this.state = {
      input: {},
      normalizedLocationData: {},
      errorLocation: false,
    };
  }

  getHomePageQuery() {
    return {
      survey_step: 'step2',
      survey: '036',
      skipQuestion: [1],
    };
  }

  getMatchesPageQuery() {
    const { user } = this.props;
    const isUserLoggedIn = user && user.isLoggedIn;
    const query = {
      survey_step: 'step2',
      survey: '032',
      src: POPUP_SURVEY_SOURCE.MATCHES_PAGE,
    };
    if (isUserLoggedIn) {
      query.skipQuestion = [10];
    }

    return query;
  }

  getLocationInputPopupQuery(locationInputPurpose) {
    const params = {
      survey: '032',
      survey_step: 'step2',
    };

    if (locationInputPurpose === 'company-follow') {
      params.src = POPUP_SURVEY_SOURCE.COMPANY_FOLLOW;
    } else if (locationInputPurpose === 'job-save') {
      params.src = POPUP_SURVEY_SOURCE.POPUP_SAVE;
    } else if (locationInputPurpose === 'job-dismiss') {
      params.src = POPUP_SURVEY_SOURCE.POPUP_DISMISS;
    }

    params.skipQuestion = [10];

    return params;
  }

  processQuestion = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const {
      zippiaHistory,
      openSignUpModal,
      homePage,
      matchesPage,
      careerSkillsPage,
      locationInputFieldPopup,
      closeLocationInputModal,
      modals: { signUp },
    } = this.props;
    if (signUp.open) {
      return;
    }
    const { input } = this.state;

    if (!_isEmpty(input.valueObj)) {
      let query = {};

      if (homePage) {
        query = this.getHomePageQuery();
      }

      if (matchesPage || careerSkillsPage) {
        query = this.getMatchesPageQuery();
      }

      if (locationInputFieldPopup) {
        const locationInputPurpose = _get(this.props, 'modals.locationInputPopup.purpose', '');
        query = this.getLocationInputPopupQuery(locationInputPurpose);
      }

      openSignUpModal({
        ...query,
      }).then(() => {
        // Close Location Input Popup if it is opened.
        closeLocationInputModal();
        zippiaHistory.pushQuery(query);
        this.sendLocationResponse();
      });
    } else {
      this.setState({
        errorLocation: true,
      });
    }
  };

  sendLocationResponse = () => {
    const { normalizedLocationData, input } = this.state;
    const { modals } = this.props;
    let currentAnswer = input.displayValue;
    const { questionList, surveyFlow, survey, utm_campaign, surveyStartTimeStamp, surveyId } =
      modals.signUp;
    const surveyResponse = {
      questionId: questionList[0].question._id,
      surveyFlow,
      surveyName: survey,
      surveyId,
      surveyStep: '1',
      utm_campaign,
      surveyStartTimeStamp,
      timeStamp: Date.now(),
    };
    if (
      currentAnswer &&
      currentAnswer.toLowerCase() ===
        (input.display_name && normalizedLocationData.display_name.toLowerCase())
    ) {
      currentAnswer = normalizedLocationData.original_name;
    }
    if (normalizedLocationData.original_name === 'Work From Home') {
      currentAnswer = normalizedLocationData.original_name;
    }

    surveyResponse.answer = [currentAnswer] || [];

    return surveyService.sendSurveyResponse(surveyResponse);
  };

  handleNormalized = (suggestedData) => {
    this.setState({
      normalizedLocationData: suggestedData,
    });
  };

  handleChange = (inputElement) => {
    this.setState(
      {
        errorLocation: false,
        input: inputElement,
      },
      () => {
        if (inputElement.suggestionSelected) {
          this.processQuestion();
        }
      }
    );
  };

  handleAutosuggestError = (errorObject) => {
    this.setState({
      errorMessage: errorObject.errorMessage,
    });
  };

  handleOnBlur = () => {
    const { input } = this.state;
    if (input.displayValue === '') {
      // clear error message if input empty
      this.handleAutosuggestError({ errorMessage: '' });
    }
  };

  getInitialLocation = () => {
    const { user, locals } = this.props;
    const geoIp = locals?.useragent?.geoIp || { geoCity: '', geoRegion: '' };
    const geoCity = geoIp['geoip-city'];
    const geoRegion = geoIp['geoip-region'];

    let initialLocation = '';
    if (user && user.userLocation && user.userLocation.length) {
      const location = user.userLocation[0];
      if (location.city) {
        initialLocation = location.city;
      }
      if (initialLocation && location.state) {
        initialLocation = `${initialLocation}, ${location.state}`;
      } else {
        initialLocation = location.state;
      }
    } else if (geoCity || geoRegion) {
      if (geoCity && geoRegion) {
        initialLocation = `${geoCity}, ${geoRegion}`;
      } else if (geoRegion) {
        initialLocation = getStateName(geoRegion);
      }
    }
    return initialLocation || '';
  };

  scrollToReference = () => {
    this.elementRef.current && window.scrollTo(0, this.elementRef.current.offsetTop);
  };

  handleFocus = (event) => {
    const inputNode = event.target;
    inputNode.setSelectionRange(0, inputNode.value.length);
    ismobileDevice() && this.scrollToReference();
  };

  renderErrors() {
    const { errorMessage, errorLocation } = this.state;
    const { locationInputFieldPopup } = this.props;
    return (
      <>
        {errorLocation && !errorMessage && (
          <div className="show-error">
            {!locationInputFieldPopup && (
              <ReactSVG src={importStatic('/ui-router/images/error.svg')} />
            )}
            {!locationInputFieldPopup ? (
              <p className="error">To get started, tell us where you&apos;d like to work.</p>
            ) : (
              <p className="error">
                Sorry, we can't find that. Please try a different city or state.
              </p>
            )}
          </div>
        )}
        {errorMessage && (
          <div className="show-error">
            <ReactSVG src={importStatic('/ui-router/images/error.svg')} />
            <p className="error">{errorMessage}</p>
          </div>
        )}
      </>
    );
  }

  renderHomeSurveyHomepage() {
    const { modals } = this.props;
    const { handleChange, handleAutosuggestError, handleOnBlur, processQuestion, handleFocus } =
      this;
    const initialLocation = this.getInitialLocation();
    return (
      <div className={classNames('mainSurveyHome', styles.mainSurveyHomeContainer)}>
        <div className="main_inner">
          <div id="sliderContainer" className={surveyPopupClasses.sliderContainer}>
            <div
              id="firstSlide"
              className="register-step textbox_big_blue first"
              style={{ display: 'block' }}
            >
              <div
                className={styles['register-container-home-page']}
                style={{
                  background: '#3072e9',
                }}
              >
                <section className="home-hero-sec container-fluid">
                  <div
                    className="jumbotron home-banner hero-featured-outer"
                    style={{
                      background: 'transparent',
                    }}
                  >
                    <div className="banner-content hero-search-wrap text-center">
                      <div className="hero-search-align">
                        <h1
                          className={classNames(
                            styles['displayHeading1'],
                            'text-uppercase white-text'
                          )}
                        >
                          Get the Job you really want
                        </h1>
                        <h3 className={classNames(styles['os-light-opensans'], 'z-mb-30')}>
                          Discover your options with your personalized career search
                        </h3>
                        <form className="input-wrap w-100" onSubmit={processQuestion}>
                          <div className="banner-input">
                            <div className="home-survey-fieldset">
                              <div className="iconAlistInput icon-map fieldset-icon" />
                              <div className="custom-typeahead AlistSurveyLocation fieldset-input">
                                <AutosuggestInput
                                  category="location"
                                  prefillValue={initialLocation}
                                  inputProps={{
                                    id: 'inputID-1',
                                    name: 'location',
                                    placeholder: 'Enter City or State',
                                  }}
                                  initWithCriteria
                                  fromHomePage
                                  onChange={handleChange}
                                  onEnterKeyDown={() => processQuestion()}
                                  onErrorCallback={(err) => handleAutosuggestError(err)}
                                  onBlur={() => handleOnBlur()}
                                  onFocus={(e) => handleFocus(e)}
                                  onNormalizeData={(suggestion) =>
                                    this.handleNormalized(suggestion)
                                  }
                                  extended
                                  surveyAutoAccept
                                />
                              </div>
                            </div>
                          </div>
                          <ZpButton
                            theme="super-primary"
                            size="big"
                            type="submit"
                            id="actionHomeID-1"
                            className="btn banner-btn"
                          >
                            <i className="fa fa-search w-100" />
                          </ZpButton>
                        </form>
                        {this.renderErrors()}
                      </div>
                    </div>
                    <FeaturedIn />
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderHomeSurveyMatches() {
    const { locationInputFieldPopup } = this.props;
    const initialLocation = this.getInitialLocation();
    const {
      handleChange,
      handleAutosuggestError,
      handleOnBlur,
      handleNormalized,
      handleFocus,
      processQuestion,
    } = this;
    return (
      <section
        className={
          locationInputFieldPopup
            ? locationInputClasses['location-popup-section']
            : styles.matchesNoUserSection
        }
      >
        {!locationInputFieldPopup && <h1 className="brandonH1">Personalized Jobs For You</h1>}
        {!locationInputFieldPopup && (
          <p ref={this.elementRef} className={styles.matchesText}>
            Get job recommendations by Zippia based on your background, workplace preferences, and
            career goals.
          </p>
        )}
        <form className={styles['input-wrap']} onSubmit={processQuestion}>
          <div
            className={classNames(styles['banner-input-matches'], {
              [`${locationInputClasses['location-input']}`]: locationInputFieldPopup,
            })}
          >
            <div
              className={classNames(styles['matches-survey-fieldset'], {
                [`${locationInputClasses['matches-survey-location-popup']}`]:
                  locationInputFieldPopup,
              })}
            >
              <div
                className={classNames(
                  'iconAlistInput',
                  'icon-map',
                  styles['fieldset-icon'],
                  'ml-3',
                  'mt-3'
                )}
              />
              <div
                className={classNames(
                  'custom-typeahead',
                  'AlistSurveyLocation',
                  styles['fieldset-input']
                )}
              >
                <AutosuggestInput
                  category="location"
                  prefillValue={initialLocation}
                  inputProps={{
                    id: 'inputID-1',
                    name: 'location',
                    placeholder: 'Enter City or State',
                  }}
                  //initWithCriteria
                  onChange={handleChange}
                  onEnterKeyDown={processQuestion}
                  onErrorCallback={(err) => handleAutosuggestError(err)}
                  onBlur={() => handleOnBlur()}
                  onFocus={(e) => handleFocus(e)}
                  onNormalizeData={(suggestion) => handleNormalized(suggestion)}
                  extended
                  surveyAutoAccept
                />
              </div>
            </div>
          </div>
          {!locationInputFieldPopup ? (
            <ZpButton
              theme="super-primary"
              size="big"
              type="submit"
              className={classNames('btn', styles['banner-btn-matches'])}
            >
              Start Looking
            </ZpButton>
          ) : (
            <ZpButton theme="primary" size="big" type="submit" className="mt-3 mb-2" isFullWidth>
              Continue
            </ZpButton>
          )}
        </form>
        {this.renderErrors()}
        {!locationInputFieldPopup && (
          <p className={styles['matchesSubText']}>
            Already have an account?{' '}
            <a target="_blank" href="/login/" className={styles['matchesLoginLink']}>
              Log In.
            </a>
          </p>
        )}
      </section>
    );
  }

  renderSkillsSurvey() {
    const { jobsCount, title } = this.props;
    const initialLocation = this.getInitialLocation();
    const {
      handleChange,
      handleAutosuggestError,
      handleOnBlur,
      handleNormalized,
      handleFocus,
      processQuestion,
    } = this;

    return (
      <section className={styles['career-skill-survey-entry']}>
        <h2
          className={classNames('brandonH2', styles['title'])}
        >{`${jobsCount.toLocaleString()} ${title} Jobs`}</h2>
        <p ref={this.elementRef} className={styles['career-skill-survey-text']}>
          Where do you want to work?
        </p>
        <form onSubmit={processQuestion}>
          <div className={styles['banner-input-skills']}>
            <div className={classNames('icon-map', styles['fieldset-icon'])} />
            <div className={styles['input-container']}>
              <AutosuggestInput
                category="location"
                prefillValue={initialLocation}
                inputProps={{
                  id: 'inputID-1',
                  name: 'location',
                  placeholder: 'Enter City or State',
                }}
                initWithCriteria
                onChange={handleChange}
                onEnterKeyDown={() => processQuestion()}
                onErrorCallback={(err) => handleAutosuggestError(err)}
                onBlur={() => handleOnBlur()}
                onFocus={(e) => handleFocus(e)}
                onNormalizeData={(suggestion) => handleNormalized(suggestion)}
                extended
                surveyAutoAccept
              />
            </div>
            <ZpButton
              theme="super-primary"
              size="big"
              type="submit"
              className={classNames('btn', styles['banner-btn-skills'])}
            >
              Find Jobs
            </ZpButton>
          </div>
        </form>
        {this.renderErrors()}
      </section>
    );
  }

  render() {
    const { homePage, matchesPage, careerSkillsPage, locationInputFieldPopup } = this.props;

    if (homePage) {
      return this.renderHomeSurveyHomepage();
    }

    if (matchesPage || locationInputFieldPopup) {
      return this.renderHomeSurveyMatches();
    }

    if (careerSkillsPage) {
      return this.renderSkillsSurvey();
    }
  }
}

HomeSurveyEntry.propTypes = propTypes;
HomeSurveyEntry.defaultProps = defaultProps;

const mapDispatchToProps = {
  openSignUpModal,
  closeLocationInputModal,
};

export default withZippiaHistory(
  connect(
    ({ modals }) => ({
      modals,
    }),
    mapDispatchToProps
  )(HomeSurveyEntry)
);
